export const locale = {
    lang: 'en',
    data: {
        TRANSFORM: 'Turn cards into tasks',
        ALL_CARDS: 'All cards',
        LIST_CARDS: 'Cards from lists',
        CATEGORIES: 'Colors',
        CARDS_HAVE: 'Cards that have',
        TYPE: 'Type',
        POINTS: 'Votes',
        OF: 'than',
        CHOOSE_CARDS: 'Choose cards',
        PLUS: 'more',
        MOINS: 'less',
        SAVE: 'Save',
        CANCEL: 'Cancel',
    }
};
